import React from 'react'

interface Props {
  page: number
  perPage: number
  /** Rows AFTER filtering — what the pager actually walks. */
  total: number
  /** Rows before filtering, so "3 of 40" can say what was filtered out. */
  unfilteredTotal?: number
  noun: string
  onPage: (p: number) => void
}

const btn = 'inline-flex items-center px-3 py-1.5 text-xs font-medium border rounded-lg '
  + 'transition-colors shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 '
  + 'disabled:opacity-50 disabled:cursor-not-allowed bg-white text-gray-700 '
  + 'border-gray-300 hover:bg-gray-50'

/**
 * Client-side pager, matching the PostsTable control row.
 *
 * Client-side is the honest choice here: both broadcast endpoints return the
 * whole set in one payload — a customer's published broadcasts and one
 * broadcast's brands are both counted in tens. Paging in the browser keeps the
 * page responsive without pretending the API is paginated when it is not.
 */
const BroadcastPagination: React.FC<Props> = ({
  page, perPage, total, unfilteredTotal, noun, onPage
}) => {
  const pages = Math.max(1, Math.ceil(total / perPage))
  const filtered = unfilteredTotal != null && unfilteredTotal !== total

  return (
    <div className="flex items-center justify-between gap-3 flex-wrap">
      <div className="text-xs text-gray-500">
        {total === 0
          ? `No ${noun} match this search`
          : `Showing ${(page - 1) * perPage + 1}-${Math.min(page * perPage, total)} of ${total} ${noun}`}
        {filtered && <span className="text-gray-400"> (filtered from {unfilteredTotal})</span>}
      </div>
      {total > perPage && (
        <div className="flex items-center space-x-2">
          <button className={btn} onClick={() => onPage(1)} disabled={page === 1}>First</button>
          <button className={btn} onClick={() => onPage(Math.max(1, page - 1))} disabled={page === 1}>
            Previous
          </button>
          <span className="text-xs text-gray-600">Page {page} of {pages}</span>
          <button className={btn} onClick={() => onPage(Math.min(pages, page + 1))} disabled={page >= pages}>
            Next
          </button>
          <button className={btn} onClick={() => onPage(pages)} disabled={page >= pages}>Last</button>
        </div>
      )}
    </div>
  )
}

export default BroadcastPagination
